/**
 * Latest Discoveries Frontend JS
 */

// Import localizations
import { __, sprintf } from "@wordpress/i18n";

// Cache for storing generated author markup
const authorMarkupCache = new Map();

document.addEventListener("DOMContentLoaded", async function () {
	// Load more functionality
	const viewSummaryContainers = document.querySelectorAll(
		".view-summary-container"
	);

	viewSummaryContainers.forEach((viewSummaryContainer) => {
		const instanceWrapper = viewSummaryContainer.closest(".latest-discoveries") || viewSummaryContainer.parentElement;

		const viewSummaryLoadMore = instanceWrapper.querySelector(".view-summary-load-more");
		const spinner = instanceWrapper.querySelector(".view-summary-spinner");

		if( spinner ) {
			spinner.style.display = "none";
		}

		const dataset = viewSummaryContainer?.dataset;

		const postPerPage = dataset?.postperpage,
			postType = dataset?.posttype,
			category = dataset?.category,
			postTag = dataset?.tag,
			showExcerpt = dataset?.showexcerpt,
			showSummary = dataset?.showsummary,
			showDate = dataset?.showdate;

		let currentPage = 1;

		if ( 'true' === dataset?.homepage ) {
			currentPage = 4;
		}

		const isMobileViewport = window.innerWidth <= 599;

		function getViewCards() {
			return Array.from(viewSummaryContainer.querySelectorAll(".view-card"));
		}

		function isCardVisible(card) {
			return card.offsetParent !== null;
		}

		function revealNextFive(fromIndex) {
			const cards = getViewCards();
			const nextBatch = cards.slice(fromIndex, fromIndex + 5);

			nextBatch.forEach((card) => card.classList.add("ld-mobile-revealed"));

			return fromIndex + nextBatch.length >= cards.length;
		}

		viewSummaryLoadMore?.addEventListener("click", async function (e) {
			e.preventDefault();

			if (isMobileViewport && "true" === viewSummaryContainer.dataset.mobilePost) {
				const cards = getViewCards();
				const lastVisibleIndex = cards.reduce(
					(lastIndex, card, index) => (isCardVisible(card) ? index : lastIndex),
					-1
				);

				if (lastVisibleIndex < cards.length - 1) {
					const reachedLastChild = revealNextFive(lastVisibleIndex + 1);

					if (reachedLastChild) {
						viewSummaryContainer.dataset.mobilePost = "false";
					}

					return;
				}

				viewSummaryContainer.dataset.mobilePost = "false";
			}

			spinner.style.display = "block";
			viewSummaryLoadMore.style.display = "none";

			const cardsBeforeFetch = getViewCards().length;

			const data = await fetchViewSummary(
				postPerPage,
				postType,
				category,
				postTag,
				++currentPage
			);

			if (!data?.hasNextPage) {
				viewSummaryLoadMore.style.display = "none";
			}

			data?.posts?.forEach((post) => {
				const cardElement = createTemplate(post, showExcerpt, showSummary, showDate);

				viewSummaryContainer.appendChild(cardElement);

				// Quick summary functionality
				cardElement
					.querySelector(`#view-summary-${post.id}`)
					?.addEventListener("click", openSummary);

				// Add event listener for close summary
				cardElement
					.querySelector(`#close-summary-${post.id}`)
					?.addEventListener("click", closeSummary);
			});

			if (isMobileViewport && data?.posts?.length) {
				const reachedLastChild = revealNextFive(cardsBeforeFetch);

				viewSummaryContainer.dataset.mobilePost = reachedLastChild ? "false" : "true";
			}

			viewSummaryLoadMore.style.display = "flex";
			spinner.style.display = "none";
		});
	});

	// Quick summary functionality
	const viewSummaryButtons = document.querySelectorAll(
		".view-card__view-summary"
	);

	viewSummaryButtons?.forEach((button) => {
		button.addEventListener("click", openSummary);
	});

	const closeSummaryButtons = document.querySelectorAll(
		".view-card__summary-close"
	);

	closeSummaryButtons?.forEach((button) => {
		button.addEventListener("click", closeSummary);
	});
});

/**
 * Fetch view summary
 *
 * @param {number} postPerPage Number of posts per page
 * @param {string} postType Post type
 * @param {string} category Category slug
 * @param {string} postTag Post tag slug
 * @param {number} page Page number
 * @return {Promise<any>}
 */
async function fetchViewSummary(
	postPerPage,
	postType,
	category,
	postTag,
	page = 1
) {
	const URL = `${window.location.origin}/wp-json/beebom/v1/view-Summary?per_page=${postPerPage}&post_type=${postType}&category=${category}&post_tag=${postTag}&page=${page}`;

	const response = await fetch(URL);

	const data = await response.json();

	return data;
}

/**
 * Create template for view summary
 *
 * @param {object} post Post object
 * @param {string} showExcerpt Show excerpt or not
 * @param {string} showSummary Show summary or not
 * @param {string} showDate Show date or not
 * @return {HTMLDivElement} Card element
 */
function createTemplate(post, showExcerpt = "true", showSummary = "true", showDate = "true") {

	const cardElement = document.createElement("div");
	cardElement.classList.add("view-card");

	const markup = `<div class="view-card__image">
						<img src="${ post.image }" alt="${ post.title }">
					</div>
					<div class="view-card__top">
						<div class="view-card__title">
							<a href="${ post.link }">${ post.title }</a>
						</div>
						${
							showExcerpt === "true"
								? `<div class="view-card__excerpt">
								${post.excerpt}
							</div>`
								: ""
						}
					</div>
					<div class="view-card__bottom">
						<div class="view-card__author-date">
							${generateAuthorMarkup(post?.authors)}
							${
								showDate === "true"
								? `<div class="view-card__date-wrapper">
										<span class="dot-svg"></span>
										<div class="view-card__date">
											${post.timeStamp}
										</div>
								</div>` : ""
							}
						</div>
						${
							( post.summary.length === 0 ) || ( "false" === showSummary )
								? ""
								: `
						<div class="view-card__view-summary" data-id="summary-${
							post.id
						}" id="view-summary-${post.id}">
							${__("View quick summary", "beebom-features")}
							<span class="view-card__view-summary-icon">
						</div>
						`
						}
					</div>
					${
						( post.summary.length === 0 ) || ( "false" === showSummary )
							? ""
							: `
					<div class="view-card__summary" id="summary-${post.id}">
						<div class="view-card__summary-container">
							<span class="view-card__summary-close" data-id="${post.id}" id="close-summary-${post.id}"></span>
							<div class="view-card__summary-text">
								${post.summary.length === 0 ? "No summary found." : post.summary}
							</div>
						</div>
					</div>
					`
					}`;

	cardElement.innerHTML = markup;

	return cardElement;
}

/**
 * Open summary
 *
 * @param {object} event Event object
 * @return {void}
 */
function openSummary(event) {
	const summary = document.querySelector(`#${event.currentTarget.dataset.id}`);

	event.currentTarget.querySelector(".view-card__view-summary-icon").classList.toggle("active");
	summary.classList.toggle("active");

	if (event.currentTarget.querySelector(".view-card__view-summary-icon").classList.contains("active")) {
		event.currentTarget.innerHTML =
			event.currentTarget.innerHTML.replace(
				'View',
				'Hide'
			);
	} else {
		event.currentTarget.innerHTML =
			event.currentTarget.innerHTML.replace(
				'Hide',
				'View'
			);
	}
}

/**
 * Close summary
 *
 * @param {object} event Event object
 * @return {void}
 */
function closeSummary(event) {
	const summary = document.querySelector(`#${event.currentTarget.dataset.id}`);
	const viewSummaryButton = document.querySelector(
		`#view-${event.currentTarget.dataset.id}`
	);
	const viewSummaryTriggerContainer = document.querySelector(
		`.view-card__view-summary[data-id="${event.currentTarget?.dataset?.id}"]`
	);

	viewSummaryButton.querySelector(".view-card__view-summary-icon").classList.remove("active");
	summary.classList.remove("active");

	if (viewSummaryTriggerContainer.querySelector(".view-card__view-summary-icon").classList.contains("active")) {
		viewSummaryTriggerContainer.innerHTML =
		viewSummaryTriggerContainer.innerHTML.replace(
				'View',
				'Hide'
			);
	} else {
		viewSummaryTriggerContainer.innerHTML =
		viewSummaryTriggerContainer.innerHTML.replace(
				'Hide',
				'View'
			);
	}
}

/**
 * Generate author markup
 *
 * @param {Object} authors Authors array
 * @return {string} Markup
 */
function generateAuthorMarkup(authors) {
	// Generate a cache key from author IDs.
	const cacheKey = authors.map(author => author.id).sort().join('-');

	// Check if we already have markup for these authors.
	if (authorMarkupCache.has(cacheKey)) {
		return authorMarkupCache.get(cacheKey);
	}

	// If not in cache, generate the markup
	let markup = '<div class="card-authors">';

	const multipleAuthorsClass = authors.length > 1 ? ' multiple-authors' : '';

	authors.forEach((author, index) => {
		let authorSeparator = '';

		if (authors.length > 1) {
			if (authors.length - 2 === index) {
				authorSeparator = '&nbsp;&&nbsp;';
			} else if (authors.length - 1 !== index) {
				authorSeparator = ',&nbsp;';
			}
		}

		let authorTag = document.querySelector('.latest-discoveries-container')?.getAttribute('data-author-tag');
		if ( ! authorTag ) {
			authorTag = 'a';
		}

		const authorAltText = sprintf(
			'Portrait of %s',
			author.name
		);

		markup += `<${authorTag} class="view-card__author${multipleAuthorsClass}" href="${author.link}">
						<img src="${author.avatar}" alt="${authorAltText}">
						<span>${author.name}</span>
					</${authorTag}>
					<span class="author-separator">${authorSeparator}</span>`;
	});

	markup += '</div>';

	authorMarkupCache.set(cacheKey, markup);

	return markup;
}
